import React from 'react';
import './AboutDepartmentsSection.css';

const departments = [
  {
    icon: '/icons/development.svg',
    name: 'DEVELOPMENT'
  },
  {
    icon: '/icons/design.svg',
    name: 'DESIGN'
  },
  {
    icon: '/icons/data-science.svg',
    name: 'DATA SCIENCE'
  },
  {
    icon: '/icons/project-management.svg',
    name: 'PROJECT MANAGEMENT'
  },
  {
    icon: '/icons/people.svg',
    name: 'PEOPLE'
  },
  {
    icon: '/icons/operations.svg',
    name: 'OPERATIONS'
  },
  {
    icon: '/icons/growth.svg',
    name: 'GROWTH'
  },
  {
    icon: '/icons/business-development.svg',
    name: 'BUSINESS DEVELOPMENT'
  },
  {
    icon: '/icons/senior-management.svg',
    name: 'SENIOR MANAGEMENT'
  }
];

const AboutDepartmentsSection = () => {
  const highlightText = (text, highlights) => {
    let highlightedText = text;
    highlights.forEach(highlight => {
      const regex = new RegExp(`(${highlight})`, 'gi');
      highlightedText = highlightedText.replace(regex, '<span class="highlight">$1</span>');
    });
    return highlightedText;
  };

  return (
    <section className="aboutdepartments-section" id="aboutdepartments">
      <div className="container">
      <div className="aboutdepartments-content-wrapper">
        {/* Main Heading */}
        <div className="aboutdepartments-main-heading">
          <h1>KNOW OUR DEPARTMENTS</h1>
        </div>

        {/* Introductory Text */}
        <div className="aboutdepartments-intro">
          <p 
            dangerouslySetInnerHTML={{ 
              __html: highlightText(
                'At Lattice Labs we have one of the most rigorous hiring processes in the industry. We cover both technical capabilities and cultural fit to ensure you get to work with great minds and great team members.',
                ['most rigorous hiring processes', 'work with great minds and great team members']
              ) 
            }}
          ></p>
        </div>

        {/* Department Grid */}
        <div className="aboutdepartments-grid">
          {departments.map((department, idx) => (
            <div className="aboutdepartments-department-block" key={idx}>
             <div className="aboutproducts-icon">
  <img src={department.icon} alt={department.title + ' icon'} />
</div>
              <div className="aboutdepartments-department-name">{department.name}</div>
            </div>
          ))}
        </div>
      </div>
      </div>
    </section>
  );
};

export default AboutDepartmentsSection;